(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/ball-row-result/assets/javascripts/ball-row-result-keno.js') >= 0) return;  svs.modules.push('/components/tur/ball-row-result/assets/javascripts/ball-row-result-keno.js');
'use strict';

svs.tur = svs.tur || {};
svs.tur.ball = svs.tur.ball || {};
svs.tur.ball.row = svs.tur.ball.row || {};
svs.tur.ball.row.result = svs.tur.ball.row.result || {};
const Events = svs.tur.ball.constants;
class Keno extends svs.tur.ball.row.result.Default {
  constructor(options) {
    const numbers = options.numbers,
      kungKeno = options.kungKeno,
      order = options.order,
      _options$manualAnimat = options.manualAnimateKungKenoHat,
      manualAnimateKungKenoHat = _options$manualAnimat === void 0 ? false : _options$manualAnimat;
    options.row = new svs.tur.ball.row.Keno({
      numbers,
      kungKeno,
      order,
      addEmptyBall: false
    });
    super(options);
    if (typeof this.row.kungKeno !== 'boolean') {
      this.kungKenoBall = _.find(this.row.balls, ball => {
        if (ball.number === this.row.kungKeno) {
          return ball;
        }
      });
      if (this.kungKenoBall) {
        this.kungKenoBall.addClass('ball-keno-has-kungkeno');
        this.kungKenoBall.addCrown(false);
      }
    }
    this.manualAnimateKungKenoHat = manualAnimateKungKenoHat;
    this.kungKenoTtimeLine = null;
  }
  classNames() {
    return ['ball-row-result-keno'];
  }
  spin() {
    let speed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    if (this.kungKenoBall) {
      gsap.set(this.kungKenoBall.$crown, {
        clearProps: 'all'
      });
    }
    super.spin(speed);
    if (!this._hasBeenAdded && !this.manualAnimateKungKenoHat) {
      this.tl.add(this.animateKungKenoHat());
      this._hasBeenAdded = true;
    }
  }
  animateKungKenoHat() {
    this.kungKenoBall.startCorrection = true;
    const tl = gsap.timeline({
      onStart: () => this.trigger(Events.RESULT_KUNGKENO_STARTED),
      onComplete: () => this.trigger(Events.RESULT_KUNGKENO_REVEALED)
    });
    const nonKungKenoBalls = _.shuffle(this.row.balls).filter(ball => ball.number !== this.kungKenoBall.number);

    nonKungKenoBalls.forEach(ball => {
      tl.to(ball.$number, 0.3, {
        scale: 0,
        opacity: 0.3
      }, '<.2');
    });

    const $crown = this.kungKenoBall.$crown;
    tl.set($crown, {
      scale: 0.2
    });
    tl.to($crown, {
      duration: 0.8,
      y: '-175%',
      opacity: 1,
      scale: 0.8,
      rotation: -360,
      ease: 'cubic.out'
    });
    tl.set($crown, {
      zIndex: 30
    });
    tl.to($crown, {
      duration: 0.7,
      y: $crown.endY,
      x: $crown.endX,
      rotation: $crown.rotation,
      scale: 1,
      ease: 'back.inOut'
    }, '-=.2');
    tl.to(this.kungKenoBall.$el, {
      duration: 0.15,
      scaleY: 0.8,
      y: 4
    }, '<.4');
    tl.to(this.kungKenoBall.$el, {
      duration: 0.2,
      scaleY: 1,
      y: 0,
      ease: 'back.out'
    }, '<.15');

    _.shuffle(nonKungKenoBalls).forEach(ball => {
      tl.to(ball.$number, 0.1, {
        scale: 1,
        opacity: 1
      }, '<0.05');
    });
    this.kungKenoTtimeLine = tl;
    return tl;
  }
  render() {
    let visible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    super.render(visible);
    if (!visible) {
      this.hideNumbers();
    } else {
      this.kungKenoBall.$crown.style.opacity = 1;
    }
    return this.$el;
  }
  hideKungKenoHat() {
    if (this.kungKenoBall) {
      this.kungKenoBall.$crown.style.opacity = 0;
    }
  }
  _scaleOutNumber(el) {
    return gsap.fromTo(el, {
      scale: 1,
      opacity: 1
    }, {
      duration: 0.3,
      scale: 0,
      opacity: 0.3
    });
  }
  _scaleInNumber() {
    return this._scaleOutNumber().play().timeScale(-2);
  }
  finish() {
    super.finish();
    if (this.kungKenoBall) {
      var _this$kungKenoTtimeLi;
      (_this$kungKenoTtimeLi = this.kungKenoTtimeLine) === null || _this$kungKenoTtimeLi === void 0 || _this$kungKenoTtimeLi.progress(1, false);
    }
  }
  skip(skipKungKeno) {
    super.skip(skipKungKeno);
    if (skipKungKeno) {
      if (!this.kungKenoTtimeLine) {
        this.animateKungKenoHat();
      }
      this.kungKenoTtimeLine.progress(1, false);
    }
  }
  destroy() {
    if (this.kungKenoTtimeLine) {
      this.kungKenoTtimeLine.clear();
      this.kungKenoTtimeLine.kill();
      this.kungKenoTtimeLine = null;
    }
    super.destroy();
  }
}
svs.tur.ball.row.result.Keno = Keno;

 })(window);